import tippy from 'tippy.js';
import tooltipConfig from '../../01-atoms/tooltip/_tooltip';

const glossaryDataUrl = '/assets/statics/data/help.json';

const loadingMessage = 'Laden...';
const errorMessage = 'Netzwerkfehler...';

tippy('[data-ref]', {
  ...tooltipConfig,
  content: loadingMessage,
  onCreate(instance) {
    // Setup our own custom state properties
    const { state } = instance;
    state.isFetching = false;
    state.src = null;
    state.error = null;
  },
  onShow(instance) {
    const { state } = instance;
    const { ref } = instance.reference.dataset;

    if (state.isFetching || state.ref || state.error) {
      instance.setContent(state.ref);
      return;
    }

    state.isFetching = true;
    fetch(glossaryDataUrl)
      .then((response) => response.json())
      .then((data) => {
        state.ref = data[ref].description;
        instance.setContent(state.ref);
      })
      .catch((error) => {
        state.error = error;
        instance.setContent(`${errorMessage} <pre>${error}</pre>`);
      })
      .finally(() => {
        state.isFetching = false;
      });
  },
  onHidden(instance) {
    const { state } = instance;
    // Unset these properties so new network requests can be initiated
    state.error = null;
  },
});

Array.prototype.slice
  .call(document.querySelectorAll('.accordion'))
  .forEach((accordion) => {
    const allowMultiple = accordion.hasAttribute('data-allow-multiple');
    const allowToggle =
      allowMultiple || accordion.hasAttribute('data-allow-toggle');

    const triggers = Array.prototype.slice.call(
      accordion.querySelectorAll('.accordion-trigger')
    );

    accordion.addEventListener('click', (event) => {
      const { target } = event;

      if (target.classList.contains('accordion-trigger')) {
        const isExpanded = target.getAttribute('aria-expanded') === 'true';
        const active = accordion.querySelector('[aria-expanded="true"]');

        if (!allowMultiple && active && active !== target) {
          active.setAttribute('aria-expanded', 'false');
          document
            .getElementById(active.getAttribute('aria-controls'))
            .setAttribute('hidden', '');

          if (!allowToggle) {
            active.removeAttribute('aria-disabled');
          }
        }

        if (!isExpanded) {
          target.setAttribute('aria-expanded', 'true');
          document
            .getElementById(target.getAttribute('aria-controls'))
            .removeAttribute('hidden');

          if (!allowToggle) {
            target.setAttribute('aria-disabled', 'true');
          }
        } else if (allowToggle && isExpanded) {
          target.setAttribute('aria-expanded', 'false');
          document
            .getElementById(target.getAttribute('aria-controls'))
            .setAttribute('hidden', '');
        }

        event.preventDefault();
      }
    });

    accordion.addEventListener('keydown', (event) => {
      const { target } = event;
      const key = event.which.toString();

      const ctrlModifier = event.ctrlKey && key.match(/33|34/);

      if (target.classList.contains('accordion-trigger')) {
        // 38 = Up, 40 = Down
        if (key.match(/38|40/) || ctrlModifier) {
          const index = triggers.indexOf(target);
          const direction = key.match(/34|40/) ? 1 : -1;
          const { length } = triggers;
          const newIndex = (index + length + direction) % length;

          triggers[newIndex].focus();

          event.preventDefault();
        } else if (key.match(/35|36/)) {
          // 35 = End, 36 = Home keyboard operations
          switch (key) {
            // Go to first accordion
            case '36':
              triggers[0].focus();
              break;
            // Go to last accordion
            case '35':
              triggers[triggers.length - 1].focus();
              break;
            default:
              break;
          }
          event.preventDefault();
        }
      }
    });

    accordion.querySelectorAll('.accordion-trigger').forEach((trigger) => {
      trigger.addEventListener('focus', () => {
        accordion.classList.add('focus');
      });

      trigger.addEventListener('blur', () => {
        accordion.classList.remove('focus');
      });
    });

    if (!allowToggle) {
      const expanded = accordion.querySelector('[aria-expanded="true"]');

      if (expanded) {
        expanded.setAttribute('aria-disabled', 'true');
      }
    }
  });
